import { render, staticRenderFns } from "./TodosFornecedores.vue?vue&type=template&id=f4d8ea2e&"
import script from "./TodosFornecedores.vue?vue&type=script&lang=js&"
export * from "./TodosFornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports